import { connect } from 'react-redux'
import VotesPanel from './VotesPanel'
import { State } from '../../dataStore/reducers/reducerType'
import { createVote, deleteVote, endAllVotes, editVote, startVote, endVote, votesActions } from '../../dataStore/slices/votes'
import { VotesSetModePayload, VotesViewProps } from '@bt-react/components/Votes'
import selectWebcastStatusForVotes from '../../dataStore/selectors/selectWebcastStatusForVotes'

type Dispatch = 'createVote' | 'deleteVote' | 'editVote' | 'startVote' |
  'setMode' | 'clearCountdown' | 'endVote' | 'endAllVotes'

const mapStateToProps = (state: State): Omit<VotesViewProps, Dispatch> => ({
  votes: state.votes.votes,
  mode: state.votes.mode,
  selectedVoteId: state.votes.selectedVoteId,
  webcastStatus: selectWebcastStatusForVotes( state ),
  countdownStart: state.votes.countdownStart
})

const mapDispatchToProps = (dispatch) : Pick<VotesViewProps, Dispatch>  => ({
  createVote: vote => dispatch(createVote(vote)),
  deleteVote: voteId => dispatch(deleteVote(voteId)),
  endAllVotes: () => dispatch( endAllVotes()),
  editVote: vote => dispatch(editVote(vote)),
  startVote: voteId => dispatch(startVote(voteId)),
  endVote: voteId => dispatch(endVote(voteId)),
  setMode: (payload: VotesSetModePayload) => dispatch( votesActions.setMode(payload)),
  clearCountdown: () => dispatch( votesActions.clearCountdown())
})

export default connect(mapStateToProps, mapDispatchToProps)(VotesPanel)
